@if (instanceCountFields && instanceCountFields.length > 0) {
  <div class="blockgrid blockgrid-sm" [ngClass]="{'l-center': !chartFields || chartFields.length <= 0}">
    @for (field of instanceCountFields; track trackById($index, field)) {
      <a class="hyperlink object-count hide-focus" style="outline: none; margin:0px !important; display:inline"  href="{{field.link}}">
        <div class="block" id="{{field.id}}" (click)="selectImage($event)" >
          <span class="xl-text">{{field.value}}</span><br>
          <span class="title">{{field.label}}</span>
        </div>
      </a>
    }
  </div>
}
